import { Component, OnInit, ChangeDetectionStrategy } from '@angular/core';
import { AuthService } from '../auth.service';
import { Router } from '@angular/router';
import { AnimationOptions } from 'ngx-lottie';

@Component({
  selector: 'admin-verification',
  templateUrl: './admin-verification.component.html',
  styleUrls: ['./admin-verification.component.scss']
})
export class AdminVerificationComponent implements OnInit {

  currentUser: any;
  options: AnimationOptions = {
    path: '/assets/animations/spaceil-admin-verification.json',
    loop: true
  };

  constructor(private readonly authService: AuthService,
              private router: Router) { }

  ngOnInit(): void {
    this.authService.getCurrentUser().then(user => {
      this.currentUser = user;
    });
  }

  backHome(): void {
    this.router.navigate(['/login']);
  }

}
